import React, { useState } from "react"
import { Row } from "react-bootstrap"
import FunctionalGroup from "./FunctionalGroup"
import getServerURL from "../../../../functions/getServerURL"
import axios from "axios"


export default function FunctionalGroupListItem({ functionalGroup, getFunctionalGroups }) {
  // STATE
  const [isExpanded, setIsExpanded] = useState(false)
  const [functionalGroupDetails, setFunctionalGroupDetails] = useState(null)
  const [fetchingFunctionalGroupDetails, setFetchingFunctionalGroupDetails] = useState(false)

  const getFunctionalGroupDetails = () => {
    setFetchingFunctionalGroupDetails(true)
    axios.get(`${getServerURL()}functional-groups/${functionalGroup.id}/`, {
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
    }).then(response => {
      let functionalGroupObject = response.data
      if (functionalGroupObject) {
        functionalGroupObject.users = functionalGroupObject.users.sort((a, b) => a.full_name.localeCompare(b.full_name))
      }

      setFunctionalGroupDetails(functionalGroupObject)
    }).catch(error => {
      console.log(error.response)
    }).finally(() => {
      setFetchingFunctionalGroupDetails(false)
    })
  }

  const handleExpand = () => {
    if (!isExpanded) {
      getFunctionalGroupDetails()
    } else {
      setFunctionalGroupDetails(null)
    }
    setIsExpanded(!isExpanded)
  }

  return (
    <React.Fragment>
      <tr onClick={ handleExpand } className={`qms-training-table-item ${ isExpanded && "active" }`}>
        <td>
          <div style={{ display: "inline-block", width: "75%" }}>{ functionalGroup.name }</div>
          {/*<div style={{ display: "inline-block", float: "right" }}>*/}
          {/*  { functionalGroup.is_published ? "Published" : "Not Published"}*/}
          {/*</div>*/}
        </td>
      </tr>
      { Boolean(isExpanded) &&
        <tr className="data-access-request-table-item-expanded">
          <td colSpan={4}>
            <Row style={{ margin: "0px" }}>
              { fetchingFunctionalGroupDetails ?
                <center>
                  <div id="not-found">
                    <img alt="loader" width={100} src={require("../../../../static/images/spinner.gif")}/>
                  </div>
                </center>
                :
                <div>
                  { functionalGroupDetails ?
                    <FunctionalGroup
                      functionalGroup={ functionalGroupDetails }
                      getFunctionalGroupDetails={ getFunctionalGroupDetails }
                      getFunctionalGroups={ getFunctionalGroups }
                    />
                    :
                    "Could not get the training details"
                  }
                </div>
              }
            </Row>
          </td>
        </tr>
      }
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/FunctionalGroupContainer/FunctionalGroupListItem.js